import type { TextInputProps } from '../TextInput/index.ts';
import { TextInputContainer } from '../TextInput/index.ts';

export interface StripeTextInputProps extends Pick<
  TextInputProps,
  'disabled' | 'error' | 'helpText' | 'label'
> {
  children?: React.ReactNode;
  focused?: boolean;
}

export function StripeElementContainer({
  children,
  disabled,
  error,
  focused,
  helpText,
  label
}: StripeTextInputProps) {
  return (
    <TextInputContainer
      disabled={disabled}
      error={error}
      focused={focused}
      label={label}
      helpText={helpText}
    >
      <div className="overflow-hidden rounded-md px-3 py-[9px]">{children}</div>
    </TextInputContainer>
  );
}
